var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "bulk-create-events-modal",
      attrs: {
        name: "bulkCreateEventsModal",
        width: "75%",
        height: "auto",
        scrollable: true,
        pivotX: 1.0,
        minWidth: 900,
        clickToClose: true
      },
      on: { "before-open": _vm.beforeOpen }
    },
    [
      _c("div", { staticClass: "bulk-create-events" }, [
        _c("div", { staticClass: "bulk-title" }, [
          _c("p", [
            _vm._v(_vm._s(_vm.getClientName) + "  - Bulk Create Events")
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-bulk",
              attrs: { disabled: _vm.downloadLoading },
              on: { click: _vm.onDownload }
            },
            [
              !_vm.downloadLoading
                ? _c("img", {
                    attrs: {
                      src: require("../../../static/img/Union.svg"),
                      alt: "union"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.downloadLoading ? _c("b-spinner") : _vm._e(),
              _vm._v("\n        Download Template\n      ")
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "upload-file" },
          [
            _c(
              "vue-dropzone",
              {
                ref: "myVueDropzone",
                attrs: {
                  "include-styling": false,
                  useCustomSlot: true,
                  id: "dropzone",
                  options: _vm.dropzoneOptions
                },
                on: { "vdropzone-file-added": _vm.sendingFile }
              },
              [
                _c("div", { staticClass: "dropzone-container" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../static/img/cloud.svg"),
                      alt: "union"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-csv" }, [
                    _vm._v("CSV File Only")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-drop" }, [
                    _vm._v("Drag & drop to upload or "),
                    _c("a", { attrs: { href: "#" } }, [_vm._v("browse")])
                  ])
                ])
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("div", { staticClass: "submission-history" }, [
          _c("p", [_vm._v("Submission History")]),
          _vm._v(" "),
          _c(
            "table",
            [
              _c(
                "tr",
                _vm._l(_vm.historyHeader, function(item) {
                  return _c("th", { key: item }, [_vm._v(_vm._s(item))])
                })
              ),
              _vm._v(" "),
              _vm.loadingHistories
                ? _c("tr", [
                    _c(
                      "td",
                      { staticClass: "text-center", attrs: { colspan: "6" } },
                      [_c("b-spinner", { attrs: { variant: "primary" } })],
                      1
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.histories, function(itemHistory) {
                return !_vm.loadingHistories
                  ? _c("ItemHistoryModal", {
                      key: itemHistory.id,
                      attrs: { item: itemHistory, clientId: _vm.clientId }
                    })
                  : _vm._e()
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("p", { staticClass: "total-text" }, [
                _vm._v(_vm._s(_vm.totalRows) + " results")
              ]),
              _vm._v(" "),
              _c("b-pagination", {
                attrs: {
                  "total-rows": _vm.totalRows,
                  "per-page": _vm.itemsPerPage,
                  pills: "",
                  "first-number": true,
                  "last-number": true
                },
                on: { change: _vm.onChangePagination },
                model: {
                  value: _vm.currentPage,
                  callback: function($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage"
                }
              })
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-21ec141a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21ec141a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/BulkCreateEvents.vue
// module id = 1973
// module chunks = 1